import { FileImageExtended, FormFile, ApiImageWithName } from 'types/Base';

const FileImageToFormFile = (image: FileImageExtended | ApiImageWithName): FormFile => ({
    id: image.id + '',
    name: image.name,
    state: { status: 'EXIST', file: image },
});

export default FileImageToFormFile;
